import IPS = require("publicsector");
import Services = require("../services");

class Service extends Services.BusinessService<IPS.Address> {

    static about = `Proxy for the property/addresses service`;

    constructor(public api: Services.API) {
        super(api, "property/addresses");
    }

}

export = Service; 